module.exports = __webpack_public_path__ + "static/media/09-tips.d8fe329c.png";